import React, { Suspense } from 'react';
import { render, hydrate } from 'react-dom';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter } from 'react-router-dom';

import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { LastLocationProvider } from 'react-router-last-location';
import { loadableReady } from '@loadable/component';
import Loading from './components/loading';
import configureStore from './store';
import App from './modules/App/App';
import './i18n';

let initialState = {};

try {
  initialState = JSON.parse(document.getElementById('__INITIAL_STATE__').textContent);
} catch (e) {
  initialState = {};
}
const { store, history } = configureStore({ initialState });

const bootstrap = (MainApp) => {
  const renderMethod = module.hot ? render : hydrate;
  renderMethod(
    <Suspense fallback={<Loading />}>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <LastLocationProvider>
              <CookiesProvider>
                <BrowserRouter>
                  <MainApp />
                </BrowserRouter>
              </CookiesProvider>
            </LastLocationProvider>
          </ConnectedRouter>
        </Provider>
    </Suspense>,
    document.getElementById('root'),
  );
};

loadableReady(() => {
  bootstrap(App);
});

